import { AgreementStatusIcon } from 'src/components/PortalList/PortalAgreementStatus';
import { mediaMaxWidth2 } from 'src/styles/layout';
import styled from 'styled-components';
import { IContractingPartyStatus } from './interfaces';
import { getSigningCaseHeaderColor } from 'src/utils/getSigningCaseHeaderColor';

export const StatusIcon = styled(AgreementStatusIcon)`
  font-size: 2em;
`;

export const StatusParagraph = styled.p<IContractingPartyStatus>`
  color: ${({ status }) => getSigningCaseHeaderColor(status)};
  margin-top: 0.3em;

  ${mediaMaxWidth2.tabletSmall`
    display: none;
  `}
`;
